import React from "react";

import styles from "./TeamNameBox.module.scss";
import { getDefaultImage } from "../../utils/GeneralUtils";
import ContentReportButton from "../../common/report/ContentReportButton";

type Props = {
  img_src?: string;
  name?: string;
  isShown: boolean;
  team_color?: string;
  openModal: () => void;
};
export const TeamNameBox: React.FC<Props> = (props) => {
  const { img_src, name, isShown, team_color, openModal } = props;

  return (
    <div
      className={
        isShown
          ? `${styles["c-teamNameBox"]} ${styles["c-teamNameBox-fixed"]}`
          : styles["c-teamNameBox"]
      }
    >
      <div
        className={
          isShown
            ? `${styles["c-teamNameBox__inner"]} ${styles["c-teamNameBox-fixed__inner"]}`
            : styles["c-teamNameBox__inner"]
        }
      >
        <div
          className={
            isShown
              ? `${styles["c-teamNameBox__picture"]} ${styles["c-teamNameBox-fixed__picture"]}`
              : styles["c-teamNameBox__picture"]
          }
          style={{ borderRight: `4px solid ${team_color}` }}
        >
          <img
            src={img_src ? img_src : getDefaultImage()}
            className={styles["f-teamName__img"]}
          />
        </div>

        <div
          className={
            isShown
              ? `${styles["c-teamNameBox__item"]} ${styles["c-teamNameBox-fixed__item"]}`
              : styles["c-teamNameBox__item"]
          }
        >
          {name !== undefined ? (
            <h1
              className={
                isShown
                  ? `${styles["c-teamNameBox__item__person-name"]} ${styles["c-teamNameBox-fixed__item__person-name"]}`
                  : styles["c-teamNameBox__item__person-name"]
              }
            >
              {name}
            </h1>
          ) : null}
          <ContentReportButton
            handler={openModal}
            wrapperClass={styles["report-btn"]}
          />
        </div>
      </div>
    </div>
  );
};

export default TeamNameBox;
